import React from 'react'
import { EntityGraphComponents } from '../index'

export const ClientOwnershipDefault = () => {
  const {
    EG_Canvas: Canvas,
    EG_Wrapper: Wrapper,
    EG_Settings: Settings,
    EG_AddNodeSidebar: AddNodeSidebar,
    EG_StyleEditSidebar: StyleEditSidebar,
    EG_SaveControls: SaveControls,
    EG_LinkEditSidebar: LinkEditSidebar,
    EG_DetailsSidebar: DetailsSidebar
  } = EntityGraphComponents

  return (
    <Wrapper levelTypeId={201} graphType='accountOwnership'>
      <Canvas>
        <Settings />
        <AddNodeSidebar />
        <StyleEditSidebar />
        <LinkEditSidebar />
        <DetailsSidebar />
      </Canvas>
      <SaveControls />
    </Wrapper>
  )
}
